import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/axios";
import { toast } from "react-toastify";

export const fetchBranches = createAsyncThunk(
  "branch/fetchBranches",
  async () => {
    const response = await apiService.get("/branch/getAllBranch");
    return response.data;
  }
);

export const addBranch = createAsyncThunk(
  "branch/addbranch",
  async (branchData) => {
    const response = await apiService.post("/branch/create", branchData);
    toast.success("Branch added successfully");
    return response.data;
  }
);

export const updateBranch = createAsyncThunk(
  "branch/updateBranch",
  async ({ branchId, updateData }) => {
    const response = await apiService.put("/branch/update", {
      branchId,
      ...updateData,
    });
    toast.success("Branch updated successfully");
    return response.data;
  }
);

export const deleteBranch = createAsyncThunk(
  "branch/deleteBranch",
  async (branchId) => {
    await apiService.put("/branch/delete", {
      branchId,
      isDelete: true,
    });
    toast.success("Branch deleted successfully");
    return branchId;
  }
);

const branchSlice = createSlice({
  name: "branch",
  initialState: {
    branches: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.branches = action.payload;
      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addBranch.fulfilled, (state, action) => {
        state.branches.push(action.payload);
      })
      .addCase(updateBranch.fulfilled, (state, action) => {
        const index = state.branches.findIndex(
          (cat) => cat._id === action.payload._id
        );
        if (index !== -1) {
          state.branches[index] = action.payload;
        }
      })
      .addCase(deleteBranch.fulfilled, (state, action) => {
        state.branches = state.branches.filter(
          (cat) => cat._id !== action.payload
        );
      });
  },
});

export const {} = branchSlice.actions;
export default branchSlice.reducer;